import { createSlice } from '@reduxjs/toolkit';
import { CampaignApi } from '../../service/CampaignApi';
import { actions } from '../Common/CallActionsOptions';
import { htmlToPlainText } from '../Common/htmlText';

const AdSetupSlice = createSlice({
  name: 'adsetup',
  initialState: {
    primaryText: "",
    description: "",
    headlines: "",
    image_cache: "",
    video_cache: "",
    // Lasting CDN URLs (cdn_url, not the expiring signed_url) for Nightlife,
    // which stores the URL and serves it later instead of downloading it now.
    image_cdn_url: "",
    video_cdn_url: "",
    audio_queue: [],
    audio_index: -1,
    uploadedImage: "",
    uploadedVideo: "",
    action: actions[10].value,
    broadcast: "",
    paymentStatus: false,
    pastedUrl: "",
    transcoding_versions: []
  },

  reducers: {
    setPastedUrl: (state, action) => {
      state.pastedUrl = action.payload;
    },
    // CMS text can be HTML - store it as plain text (Primary Text is a single-line input).
    setPrimaryText: (state, action) => {
      state.primaryText = htmlToPlainText(action.payload, false);
    },
    setDescription: (state, action) => {
      state.description = htmlToPlainText(action.payload);
    },
    setHeadlines: (state, action) => {
      state.headlines = action.payload;
    },
    setPaymentStatus: (state, action) => {
      state.paymentStatus = action.payload;
    },
    setUploadedImage: (state, action) => {
      state.uploadedImage = action.payload;
    },
    setUploadedVideo: (state, action) => {
      state.uploadedVideo = action.payload;
    },
    setImageCache: (state, action) => {
      state.image_cache = action.payload;
    },
    setVideoCache: (state, action) => {
      state.video_cache = action.payload;
    },
    setImageCdnUrl: (state, action) => {
      state.image_cdn_url = action.payload;
    },
    setVideoCdnUrl: (state, action) => {
      state.video_cdn_url = action.payload;
    },
    setTranscodingVersions: (state, action) => {
      state.transcoding_versions = action.payload;
    },
    setAction: (state, action) => {
      state.action = action.payload;
    },
    setAudioQueue: (state, action) => {
      state.audio_queue = action.payload;
      state.audio_index = 0; // Start playing from the first audio
    },
    setAudioIndex: (state, action) => {

      state.audio_index = action.payload; // Start playing from the first audio
    },
    playNextAudio: (state) => {
      state.audio_index = (state.audio_index + 1) % state.audio_queue.length; // Loop back to the first audio after the last one
    },
    playPreviousAudio: (state) => {
      state.audio_index = (state.audio_index - 1 + state.audio_queue.length) % state.audio_queue.length; // Loop back to the last audio after the first one
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(CampaignApi.endpoints.getAllCampaigns.matchFulfilled, (state, { payload }) => {
      const hd_mp4Url = payload?.converted_videos?.hd_mp4;
      const sd_mp4Url = payload?.converted_videos?.sd_mp4;
      const audioPaths = payload?.field_music_file?.map((audio) => `https://nightlife.net/${audio?.filepath}`);
      console.log(payload.image_cache_path);

      return {
        ...state,
        description: payload.body,
        headlines: payload.title,
        primaryText: payload.teaser,
        image_cache: payload.image_cache_path,
        video_cache: hd_mp4Url
          ? `https://nightlife.net/${hd_mp4Url}`
          : sd_mp4Url
            ? `https://nightlife.net/${sd_mp4Url}`
            : '',
        audio_queue: audioPaths ? audioPaths : [],
        audio_index: 0, // Start playing from the first audio,
        broadcast: payload.field_live_video ? payload.field_live_video[0].value : "",
        transcoding_versions: []
      }
    })
  }
});

export const { setDescription, setPaymentStatus, setHeadlines, setUploadedImage, setUploadedVideo, setImageCache, setVideoCache, setImageCdnUrl, setVideoCdnUrl, setTranscodingVersions, setPrimaryText, setAction, setAudioQueue, setAudioIndex,
  playNextAudio,
  playPreviousAudio, setPastedUrl } = AdSetupSlice.actions;

export default AdSetupSlice.reducer;
